/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WarehouseCaseMessageAttachmentDTOFromJSON, WarehouseCaseMessageAttachmentDTOToJSON, } from './WarehouseCaseMessageAttachmentDTO';
/**
 * @export
 */
export const WarehouseCaseMessageDTOAuthorEnum = {
    Customer: 'CUSTOMER',
    Support: 'SUPPORT'
};
/**
 * Check if a given object implements the WarehouseCaseMessageDTO interface.
 */
export function instanceOfWarehouseCaseMessageDTO(value) {
    return true;
}
export function WarehouseCaseMessageDTOFromJSON(json) {
    return WarehouseCaseMessageDTOFromJSONTyped(json, false);
}
export function WarehouseCaseMessageDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'body': json['body'] == null ? undefined : json['body'],
        'author': json['author'] == null ? undefined : json['author'],
        'sentAt': json['sentAt'] == null ? undefined : (new Date(json['sentAt'])),
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'deletedAt': json['deletedAt'] == null ? undefined : (new Date(json['deletedAt'])),
        'editedAt': json['editedAt'] == null ? undefined : (new Date(json['editedAt'])),
        'attachments': json['attachments'] == null ? undefined : (json['attachments'].map(WarehouseCaseMessageAttachmentDTOFromJSON)),
    };
}
export function WarehouseCaseMessageDTOToJSON(json) {
    return WarehouseCaseMessageDTOToJSONTyped(json, false);
}
export function WarehouseCaseMessageDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'body': value['body'],
        'author': value['author'],
        'sentAt': value['sentAt'] == null ? undefined : ((value['sentAt']).toISOString()),
        'deleted': value['deleted'],
        'deletedAt': value['deletedAt'] == null ? undefined : ((value['deletedAt']).toISOString()),
        'editedAt': value['editedAt'] == null ? undefined : ((value['editedAt']).toISOString()),
        'attachments': value['attachments'] == null ? undefined : (value['attachments'].map(WarehouseCaseMessageAttachmentDTOToJSON)),
    };
}
